module.exports = __webpack_public_path__ + "assets/img/logo.27e47a1f.png";